import { render, staticRenderFns } from "./preview-phone.vue?vue&type=template&id=685e49c3&scoped=true"
import script from "./preview-phone.vue?vue&type=script&lang=ts"
export * from "./preview-phone.vue?vue&type=script&lang=ts"
import style0 from "./preview-phone.vue?vue&type=style&index=0&id=685e49c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e49c3",
  null
  
)

export default component.exports